import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

const CandidatesDashboardV2 = lazy(() => import("./dashboardV2"));
const CandidateCreate = lazy(() => import("./create"));
const CandidateDetails = lazy(() => import("./details"));
const ImportCandidates = lazy(() => import("./importation"));
const CandidatesFup = lazy(() => import("./fup"));
const ErrorPage = lazy(() => import("@root/error"));

export const candidatesRoutes: RouteObject[] = [
  {
    path: "/v2/candidates/dashboard",
    element: <CandidatesDashboardV2 />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/v2/candidate/create",
    element: <CandidateCreate />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/v2/candidates/import",
    element: <ImportCandidates />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/v2/candidate/:id",
    element: <CandidateDetails />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/v2/candidate/:id/:navigation",
    element: <CandidateDetails />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/v2/candidates/fup",
    element: <CandidatesFup />,
    errorElement: <ErrorPage />,
  },
];
